<template>
  <div>
    <v-row id="create" class="ma-0">
      <v-col cols="12" class="px-0 py-0">
        <!-- 1.캘린더 헤더 (일자선택) -->
        <v-sheet>
          <v-toolbar flat>
            <v-btn fab text small color="grey darken-2" @click="prev">
              <v-icon color="grey"> mdi-chevron-left </v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-toolbar-title v-if="$refs.calendar" class="month-title">
              {{ title }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn fab text small color="grey darken-2" @click="next">
              <v-icon color="grey"> mdi-chevron-right </v-icon>
            </v-btn>
          </v-toolbar>
        </v-sheet>

        <!-- 2. 캘린더 내용 -->
        <v-sheet style="height: calc(100vh - 160px); position: relative">
          <v-calendar
            ref="calendar"
            v-model="focus"
            color="primary"
            type="month"
            :events="events"
            :event-color="getEventColor"
            :event-text-color="getEventTextColor"
            :weekday-format="getDay"
            :month-format="getMonth"
            @click:date="focusDay"
            @click:day="focusDay"
            @change="updateRange"
            min-weeks="6"
          >
          </v-calendar>
        </v-sheet>
      </v-col>
    </v-row>

<!--    <calendar-detail-dialog-->
<!--      v-bind:detailObjProps="detailObj"-->
<!--      v-bind:applBtnFlag="GET_APPL_MENU_USE_YN"-->
<!--      v-on:goApplMenuList="goApplMenuList"-->
<!--    ></calendar-detail-dialog>-->

    <v-dialog v-model="isShowDetail" v-if="isShowDetail" fullscreen>
      <attendance-sta @close="isShowDetail = false" :currentYmd="currentYmd"></attendance-sta>
    </v-dialog>

  </div>
</template>

<script>
/* 캘린더 컴포넌트 */
// import CalendarDetailDialog from '@/components/calendar/dialog/CalendarDetailDialog.vue';
import AttendanceSta from "@/views/home/AttendanceSta.vue";
import { mapGetters } from 'vuex';
import { getOrgGntWorkStaPsnlCalendarMonList } from '@/api/calendar.js';
import routerConstants from '@/const/routerConstants.js';
import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import 'dayjs/locale/ko';

dayjs.extend(isBetween);
dayjs.locale('ko');

export default {
  data: () => ({
    calendarDate: '',
    title: '', // 캘린더 타이틀
    events: [], // 캘린더 일정목록
    focus: '',

    dailyInOutTimeObj: {}, // 일별출퇴근시간
    detailObj: {}, // 일정상세

    // 일정추가버튼 관련
    fab: false,
    hover: false,
    right: true,
    bottom: true,

    // 근태 텍스트 컬러 (고정, '_attendanceChip.scss'참고)
    gntTextColorObj: {
      bcFFD49A: 'ff7936',
      bcFFE79A: 'ff9204',
      bcA6E5BA: '0fa941',
      bc9CCBFC: '087ef7',
      bcD7DADD: '505961',
    },
    currentYmd : '',
    isShowDetail : false
  }),

  watch: {
    top(val) {
      this.bottom = !val;
    },
    right(val) {
      this.left = !val;
    },
    bottom(val) {
      this.top = !val;
    },
    left(val) {
      this.right = !val;
    },
  },

  computed: {
    ...mapGetters(['GET_USER_DATA']),
  },

  methods: {
    /* 기간 이전이후 선택 */
    prev() {
      this.$refs.calendar.prev();
    },
    next() {
      this.$refs.calendar.next();
    },

    /* 캘린더 포맷 - 요일, 월 */
    getDay(date) {
      const daysOfWeek = ['일', '월', '화', '수', '목', '금', '토'];
      return daysOfWeek[date.weekday];
    },
    getMonth(date) {
      const monthName = [
        '1월',
        '2월',
        '3월',
        '4월',
        '5월',
        '6월',
        '7월',
        '8월',
        '9월',
        '10월',
        '11월',
        '12월',
      ];
      return monthName[date.month - 1];
    },

    /* 캘린더 일정 컬러 */
    getEventColor(event) {
      return event.color;
    },
    getEventTextColor(event) {
      return event.textColor;
    },

    /* 캘린더 변경이벤트 : 초기or기간변경시 -> 일정 및 캘린더타이틀 세팅 */
    updateRange({ start }) {
      // +. 공통 스피너 ON
      this.$store.commit('SPINNER/ON_COMMON_SPINNER');

      // 1. 캘린더 타이틀 세팅 (format : 'YYYY년 MM월')
      const startDate = dayjs(start.date);
      this.title = startDate.format('YYYY년 MM월');
      this.calendarDate = startDate.format('YYYYMM');

      // 2. 월단위 캘린더 목록조회
      this.getPsnlCalendarMonList();
    },

    focusDay(day){
      const filterItems = this.events.filter((event) => {
        const startDate = new Date(event.start);
        const endDate = new Date(event.end);
        const currentDate = new Date(day.date);
        return startDate <= currentDate && currentDate <= endDate;
      });
      if(filterItems.length === 0) return;
      if(filterItems[0].gubun === 'H') return;
      this.currentYmd = day.date;
      this.isShowDetail = true;
    },

    /* 신청서 작성 화면이동 */
    goApplMenuList() {
      this.$router.push({ name: routerConstants.ApplicationMenu }); // 신청서메뉴페이지로 이동
    },

    parseDate(date){
      return date.substring(0, 4) + '-' + date.substring(4, 6) + '-' + date.substring(6);
    },

    /* 월단위 캘린더 목록조회 */
    getPsnlCalendarMonList() {

      this.events = [];

      // 1. api 호출
      getOrgGntWorkStaPsnlCalendarMonList({
        enterCd : this.GET_USER_DATA.ssnEnterCd
        , sabun : this.GET_USER_DATA.ssnSabun
        , startYm: this.calendarDate
      }).then((response) => {
        //근태
        const attendanceList = response.data.data.attendanceList;
        attendanceList.forEach((item) => {
          this.events.push({
            name: item.name + ' [' + item.gntNm + ']',
            start: this.parseDate(item.sYmd),
            end: this.parseDate(item.eYmd),
            color: this.$store.getters.GET_USER_DATA.ssnSabun === item.sabun ? '#3cb149' : '#808080',
            textColor: 'white',
            timed: true,
            seq: item.seq,
            gubun: 'A'
          });
        });

        const holidayList =response.data.data.holidayList;
        holidayList.forEach((item) => {
          this.events.push({
            name: item.holidayNm,
            start: this.parseDate(item.ymd),
            end: this.parseDate(item.ymd),
            color: 'white',
            textColor: 'red',
            timed: true,
            gubun: 'H'
          });
        });
      }).finally(() => {
        this.$store.commit('SPINNER/OFF_COMMON_SPINNER');
      });

    },
  },

  mounted() {
    this.$refs.calendar.checkChange();
  },

  components: {
    AttendanceSta,
  },
};
</script>

<style>
.v-speed-dial--right {
  right: 24px !important;
}
/* .v-speed-dial--bottom {
  bottom: 94px !important;
} */
.v-calendar-weekly__week > .v-calendar-weekly__day:first-child .v-calendar-weekly__day-label button{
  color : #F44336;
}
.v-calendar-weekly__week > .v-calendar-weekly__day:last-child .v-calendar-weekly__day-label button{
  color : #1976D2;
}
</style>
